import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9950)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2184 24.2419C15.7424 24.2419 18.9126 22.7309 21.113 20.323L20.5275 19.6786C19.8029 18.881 18.5677 18.8128 17.7588 19.5258L16.5098 20.6268C14.8107 22.1246 12.228 22.0301 10.644 20.4123L9.86301 19.6146C9.11306 18.8486 7.88421 18.822 7.10133 19.5547L4.81058 21.6984C6.85279 23.2921 9.42436 24.2419 12.2184 24.2419ZM22.2202 18.1573L22.5045 18.4703C23.6121 16.6547 24.25 14.5227 24.25 12.2419C24.25 9.47648 23.3121 6.92949 21.7361 4.90017C21.4432 4.97507 21.1632 5.11841 20.9214 5.33156L19.6724 6.43251C17.9733 7.93033 15.3906 7.83592 13.8066 6.21806L13.0256 5.42041C12.2756 4.65445 11.0468 4.62775 10.2639 5.3604L7.05042 8.36779L5.48708 6.71536L8.70058 3.70796C10.3899 2.12696 13.0417 2.18458 14.66 3.83746L15.4409 4.63511C16.1751 5.38484 17.3719 5.42859 18.1593 4.73448L19.4082 3.63353C19.6179 3.44876 19.8407 3.28832 20.0734 3.15197C17.9656 1.33852 15.2204 0.241943 12.2184 0.241943C6.18258 0.241943 1.18485 4.67474 0.319346 10.4543C1.96636 9.50871 4.10491 9.75592 5.48829 11.1688L6.39147 12.0913C7.09349 12.8084 8.22595 12.884 9.01806 12.2667L11.6954 10.1805C13.3024 8.92838 15.5774 8.98895 17.1147 10.3248L20.7603 13.4928L19.2594 15.2014L15.6137 12.0335C14.9013 11.4144 13.847 11.3863 13.1024 11.9667L10.425 14.0529C8.71568 15.3848 6.27196 15.2215 4.75707 13.6743L3.8539 12.7518C3.10394 11.9859 1.87509 11.9591 1.09222 12.6918L0.25 13.48C0.510464 16.0146 1.56188 18.3155 3.15401 20.1333L5.538 17.9022C7.22736 16.3212 9.87909 16.3788 11.4974 18.0317L12.2784 18.8293C13.0125 19.579 14.2093 19.6229 14.9967 18.9288L16.2457 17.8278C17.991 16.2892 20.6566 16.4363 22.2202 18.1573Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_9950">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.25 0.241943)"
        />
      </clipPath>
    </defs>
  </svg>
)
